import { updateAssignmentUnitEpicReducer } from "./epicsV2.js";
const getUpdateAssignmentUnitEpicReducer = () => updateAssignmentUnitEpicReducer;
const rootEpic = updateAssignmentUnitEpicReducer.epic;
export {
  rootEpic as default,
  getUpdateAssignmentUnitEpicReducer,
  rootEpic
};
//# sourceMappingURL=epics.js.map
